import TheoryReviewTopSidebar from './theory-review-top-sidebar'

export default TheoryReviewTopSidebar
